/**
 * Created by lenovo on 2017/2/14.
 */
import React, {
    Component,
    PropTypes
}from 'react';
import {ellaUrl} from '../../../path.config'
import {Link} from 'react-router'
import ellaService from 'SERVICES/purifier/ella/ellaService'
import Tip from 'COMPONENT/tip'
import FormInput from 'CONFIG/component/form/formInput'
import FormInputSimple from 'CONFIG/component/form/formInputSimple'
import {alertTip,resultTip} from 'UTIL/common'
import {language,errToSuc,errorShow,successShow} from 'UTIL/common'
import BoxHeaderCreate from 'CONFIG/component/boxHeaderCreate'
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
export default class SubsystemEdit extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.state = {
            url: ellaUrl,
        }
    }
    componentDidMount(){
        var id = this.props.params.id;
        ellaService.subsystemToUpdate(id).then(body=>{
            console.log(body.data)
            const json = body.data.subsystem ;
            $("#name").val(json.name);
            $("#number").val(json.number);
            $("#remark").val(json.remark);
            $("#url").val(json.url);
        })
    }
    submit(event) {
        errToSuc();
        event.preventDefault();
        const name = $.trim($('#name').val());
        const url = $.trim($('#url').val());
        const number = $.trim($('#number').val());
        const remark = $.trim($('#remark').val());
        const arr = {
            "name": name,
            "url": url,
            "number": number,
            "remark" : remark,
            id : this.props.params.id,
        };
        if(name == ''){
            errorShow('name');
        }
        if(url == ''){
            errorShow('url');
        }
        if(number == ''){
            errorShow('number');
        }
        if($("[name='error']").length == 0){
            const data = JSON.stringify(arr);
            ellaService.subsystemDoAddOrUpdate({data}).then(body=>{
                resultTip(body,'/ella/permission/subsystemIndex')
            })
        }

    }
    render() {
        return (
            <div>
                <ContentHeader nameLg="Subsystem" nameSm="EditSubsystem"/>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <BoxHeaderCreate name={language()['EditSubsystem']}/>
                        <div className="box-body">
                            <Tip ids=""/>
                            <form className="form-horizontal">
                                <FormInput name="SubsystemName" id="name"/>
                                <FormInput name="SubsystemNumber" id="number"/>
                                <FormInput name="AccessPath" id="url"/>
                                <div className="row form-group">
                                    <label  className="multi-label control-label col-xs-2">{language()['remark']} </label>
                                    <div className="col-xs-3">
                                        <textarea type="text" className="form-control" placeholder={language()['remark']} id='remark'  />
                                    </div>
                                </div>
                            </form>
                            <div className="row form-group">
                                <div className="col-xs-2 text-center">
                                </div>
                                <div className="col-xs-1 text-center">
                                    <Link to={"/ella/permission/subsystemIndex"} className="btn btn-default">{language()['return']}</Link>
                                </div>
                                <div className="col-xs-1 text-center" >
                                    <button id="btnSubmit" className="btn btn-success" onClick={this.submit.bind(this)}>{language()['submit']}</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/permission/subsystem/subsystemEdit.js